<template>
  <div>
    <l-tabs
      :items="(session.productType === 'VIDEO' || session.productType === 'TEXT' || session.productType === 'PODCAST')? items : items2"
      :selected="selectedTab"
      @input="updateSelected"
    >
      <template #ce>
        <p v-if="session.productType === 'PODCAST'">
          To receive a certificate of completion for this course you must: <br />
          1) Purchase the course or add it to your Summit Subscription<br />
          2) Log in to your Summit Account to access the evaluation and post test.<br />
        </p><p />
        <course-ce-info
          id="info"
          :session="session"
          :ce-info="ceInfo"
          :course-id="masterCourseId"
        />
      </template>
      <template #faq>
        <course-podcast-faq v-if="session.productType === 'PODCAST'" />
        <course-faq v-else />
      </template>
    </l-tabs>
  </div>
</template>

<script>
function buildInstructorBio({
  bio,
  disclosures,
}) {
  return `<p>${bio}</p> ${disclosures}`;
}

export default {
  props: {
    selected: {
      type: String,
      default: '',
    },
    ceInfo: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
    ashaReview: {
      type: Boolean,
      default: false,
    },
    masterCourseId: {
      type: String,
      default: '',
    },
  },
  emits: ['input'],
  data() {
    return {
      selectedTab: this.getTabNumber(this.selected),
      items: [
        {
          name: 'description',
          title: 'Course Description',
          text: this.session.description + '<h3>Highlights</h3>' + this.session.highlights + this.getDisclosure(),
        },
        {
          name: 'objectives',
          title: 'Learning Objectives',
          text: this.session.objectives,
        },
        {
          name: 'outline',
          title: 'Outline',
          text: this.session.outline,
        },
        {
          name: 'bio',
          title: 'Instructor Bio & Disclosures',
          // there are some instances where there are multiple instructors, so we want build the string then
          // join them with an `hr` so there is sort of division. This is uncommon, but still happens
          text: this.session.instructors.map(buildInstructorBio).join('<hr />'),
        },
        {
          name: 'ce',
          title: 'CE Credits',
        },
        {
          name: 'faq',
          title: 'FAQs',
        },
      ],
      items2: [
        {
          name: 'description',
          title: 'Course Description',
          text: this.session.description + '<h3>Highlights</h3>' + this.session.highlights,
        },
        {
          name: 'objectives',
          title: 'Learning Objectives',
          text: this.session.objectives,
        },
        {
          name: 'outline',
          title: 'Outline',
          text: this.session.outline,
        },
        {
          name: 'bio',
          title: 'Instructor Bio & Disclosures',
          // there are some instances where there are multiple instructors, so we want build the string then
          // join them with an `hr` so there is sort of division. This is uncommon, but still happens
          text: this.session.instructors.map(buildInstructorBio).join('<hr />'),
        },
        {
          name: 'ce',
          title: 'CE Credits',
        },
      ],
      setDisclosure: this.getDisclosure(),
      disclosure: '',
    };
  },
  watch: {
    selected(s) {
      this.selectedTab = this.getTabNumber(s);
    },
    session(newVal, oldVal) {
      this.selectedSession = newVal;
      this.items[0].text = this.selectedSession.description + '<h3>Highlights</h3>' + this.selectedSession.highlights + this.getDisclosure();
      this.items[1].text = this.selectedSession.objectives;
      this.items[2].text = this.session.outline;
      this.items2[0].text = this.items[0].text;
      this.items2[1].text = this.items[1].text;
      this.items2[2].text = this.items[2].text;
      this.items.selectedSession = newVal;
      this.items2.selectedSession = newVal;
    },
  },
  // doing it this way allows the item name to be passed in, but the the main tab component uses index based
  // tab switching, so this makes it easy to deal with. Passing/emitting the value up to the main page so we
  // can do more things with it on item changes. Mainly with the CE validation, there is a button that needs
  // to switch the tabs over to the CE tab.
  methods: {
    getTabNumber(name) {
      return this.items?.findIndex(item => item.name === name) || 0;
    },
    updateSelected(event) {
      // we cant find the item by the name, just use the first in the list
      this.$emit('input', this.items[event]?.name || this.items[0].name);
    },
    getDisclosure() {
      if (this.masterCourseId === 'CDIRJK.1') {
        return 'DISCLOSURE: This presentation will focus exclusively on DIR Floortime and will not include information on other similar or related services.';
      }
      else {
        return '';
      }
    },
  },
};
</script>
